// extracted by mini-css-extract-plugin
export default {"container":"Products_container__QoQHa"};